import UnitBlockWidget from "./UnitBlockWidget";
import UnitSchemeWidget from "./UnitSchemeWidget";

/**
 * Реестр виджетов.
 *
 * Новый тип виджета добавляется здесь одной записью — PageCanvas.jsx
 * и WidgetRenderer.jsx при этом не меняются.
 *
 * Резолвер для "UNIT" ничего не спрашивает у пользователя явно:
 * вариант (Блок/Схема) определяется автоматически по unit.isDiagram,
 * как и договаривались — отдельного выбора типа в UI нет.
 */
const registry = {
	UNIT: (widget) => {
		if (!widget.unit) return null;
		return widget.unit.isDiagram ? UnitSchemeWidget : UnitBlockWidget;
	},
};

export function resolveWidgetComponent(widget) {
	const resolver = registry[widget.widgetType];
	return resolver ? resolver(widget) : null;
}
